"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { ErrorPageContent } from "@/components/ErrorPageContent/ErrorPageContent";

// Rendered above the locale layout, so no next-intl provider is available here.
export const AuthNotConfiguredState: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-dvh w-dvw items-center justify-center bg-background"><ErrorPageContent errorCode="503" title="Trimble sign-in is not configured" description="This deployment is missing NEXT_PUBLIC_TID_CONFIGURATION_ENDPOINT or NEXT_PUBLIC_TID_CLIENT_ID, so nobody can sign in. Set both and restart the app." /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};